<template>
  <div class="new-user-form-wrapper">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-4 col-lg-4 col-12">
          <div class="picture-upload-form text-center">
            <div class="picture-upload-form__header">
              <p class="text-secondary-orange font-semibold">Upload Picture</p>
            </div>
            <div class="my-3">
              <image-upload
                @input="handleImageUpload($event)"
                @remove-image="removeImage"
                :isUploadingImage="isUploadingImage"
              />
            </div>
          </div>
        </div>
        <div class="col-md-8 col-lg-8 col-12">
          <div class="new-user-form__col-two__header">
            <p class="text-secondary-orange font-semibold">User Details</p>
          </div>
          <div class="input-row">
            <div class="new-user-form__single-input-wrapper">
              <label for="firstname" class="label">First Name</label>
              <input type="text" class="input" v-model="newUser.firstName" />
            </div>
            <div class="new-user-form__single-input-wrapper">
              <label for="middlename" class="label">Middle Name</label>
              <input type="text" class="input" v-model="newUser.middleName" />
            </div>
          </div>
          <div class="input-row">
            <div class="new-user-form__single-input-wrapper">
              <label for="lastname" class="label">Last Name</label>
              <input type="text" class="input" v-model="newUser.lastName" />
            </div>
            <div class="new-user-form__single-input-wrapper">
              <label for="gender" class="label">Gender</label>
              <el-select v-model="newUser.gender" placeholder="">
                <el-option
                  v-for="gender in genders"
                  :key="gender"
                  :label="gender"
                  :value="gender"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="input-row">
            <div class="new-user-form__single-input-wrapper">
              <label for="email" class="label">Work Email</label>
              <input type="text" class="input" v-model="newUser.workEmail" />
            </div>
            <div class="new-user-form__single-input-wrapper">
              <label for="number" class="label">Phone Number</label>
              <input type="text" class="input" v-model="newUser.phoneNumber" />
            </div>
          </div>
          <div class="input-row">
            <div class="new-user-form__single-input-wrapper">
              <label for="employment-type" class="label">Employment Type</label>
              <el-select v-model="newUser.employmentType" placeholder="">
                <el-option
                  v-for="employmentType in employmentTypes"
                  :key="employmentType"
                  :label="employmentType"
                  :value="employmentType"
                >
                </el-option>
              </el-select>
            </div>
            <div class="new-user-form__single-input-wrapper">
              <label for="role" class="label">Roles</label>
              <el-select v-model="newUser.roles" placeholder="">
                <el-option
                  v-for="role in roles"
                  :key="role.id"
                  :label="role.name"
                  :value="role.name"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr />
    <advanced-details-form />
    <div class="button-wrapper">
      <button
        class="button button-secondary button-long"
        @click="$router.push({ name: 'UsersAndGr' })"
      >
        Cancel
      </button>
      <button
        class="button button-primary button-long"
        :disabled="disableButton"
        @click="createUser"
      >
        <button-loader v-if="creatingUser" />
        <span v-else>Add User</span>
      </button>
    </div>
  </div>
</template>

<script>
import AdvancedDetailsForm from "./AdvancedDetailsForm";
export default {
  components: {
    AdvancedDetailsForm,
  },
  data() {
    return {
      newUser: {
        firstName: "",
        middleName: "",
        lastName: "",
        gender: "",
        workEmail: "",
        phoneNumber: "",
        employmentType: "",
        roles: "",
        // imageurl: "",
      },
      genders: ["Male", "Female"],
      employmentTypes: [
        "Full-time",
        "Part-time",
        "Intern",
        "Company-paid Temporary",
        "Independent Contractor",
        "Agency-paid Temporary",
        "Vendor Employee",
        "Volunteer",
      ],
      creatingUser: false,
      roles: [],
      isUploadingImage: false,
    };
  },
  computed: {
    disableButton() {
      return this.shouldDisableButton(this.newUser);
    },
  },
  mounted() {
    let roles = localStorage.getItem("roles");
    if (roles) {
      this.roles = roles;
    } else {
      this.getRoles();
    }
  },
  methods: {
    async createUser() {
      this.creatingUser = true;
      try {
        await this.$_createUser(this.newUser);
        this.onCreateUser();
      } catch (error) {
        this.handleError(error);
        console.log(error);
        this.creatingUser = false;
      }
    },
    async getRoles() {
      try {
        let response = await this.$_getRoles();
        console.log("nnnnnnnnnnnnnn",response);
        this.roles = response.data.data;
      } catch (error) {
        this.handleError(error);
      }
    },
    onCreateUser() {
      this.creatingUser = false;
      this.generateToast("User has successfully been created", "success");
      this.resetUser();
      this.$store.dispatch("resetUserList");
      this.$router.push({ name: "UsersAndGroups" });
    },
    resetUser() {
      this.newUser = {
        firstName: "",
        middleName: "",
        lastName: "",
        gender: "",
        workEmail: "",
        phoneNumber: "",
        employmentType: "",
        roles: "",
      };
    },
    async handleImageUpload(image) {
      this.isUploadingImage = true;
      try {
        let response = await this.uploadImage(image);
        this.newUser.imageurl = response;
        // console.log("imageurl", response);
        this.isUploadingImage = false;
        this.generateToast("Image uploaded", "success");
      } catch (error) {
        this.handleError(error);
        this.isUploadingImage = false;
      }
    },
    removeImage() {
      this.newUser.imageurl = null;
    },
  },
};
</script>

<style scoped>
.new-user-form-wrapper {
  margin: 2rem 0;
}
.picture-upload-form {
  border: 1px solid #edf2ef;
  border-radius: 10px;
  padding: 1.55rem 1rem;
}
.picture-upload-form__img-wrapper {
  position: relative;
}
.user-img {
  width: 10rem;
  margin: 1.5rem auto;
}
.upload-img-icon {
  position: absolute;
  right: 3.5rem;
  bottom: 1rem;
}
.picture-upload-form__meta {
  padding-top: 1rem;
}
.label {
  font-size: 0.9rem;
}
.input {
  margin-bottom: 0.5rem;
}
.new-user-form__col-three {
  padding-top: 1.25rem;
}
hr {
  width: 60%;
  margin: 2rem auto;
}
.input-row {
  width: 100%;
  display: flex;
}
.input-row > div {
  width: 100%;
  padding-right: 1rem;
}
@media screen and (max-width: 768px) {
  .input-row {
    flex-direction: column;
  }
  .input-row div {
    width: 100%;
  }
}
</style>
